<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 8L7.2255 10.6667L6.66667 10.1295L8.87833 8L6.66667 5.8705L7.2255 5.33333L10 8Z" fill="#080828"/>
</svg>